import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1),
    border: 1,
    borderRadius: theme.shape.borderRadius,
    borderStyle: 'solid',
    borderColor: theme.palette.grey[500],
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  },
  productInfo: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1rem',
  },
  image: {
    width: '100px',
    height: '100px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.spacing(1),
    marginRight: theme.spacing(2),
  },
  productDetails: {
    paddingTop: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '1rem',
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },
  },
  typographyName: {
    fontWeight: 700,
    textAlign: 'justify',
  },
  typographyPrice: {
    fontWeight: 600,
    textAlign: 'justify',
    color: '#03a600',
  },
  boxTrashIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
